import React from 'react';

const ResultsPendingScreen = () => {
	return (
		<div className="flex flex-col justify-center items-center w-full flex-1 h-full px-4">
			<div className="flex flex-col justify-center items-center w-full mx-auto max-w-[426px] gap-2">
				<h2 className="text-lg md:text-2xl font-bold text-blue-500 text-center">Results not declared yet!</h2>
				<p className="text-sm md:text-base text-center w-full h-full font-[500] font-poppins text-[#544D4F]">
					Results have not been declared yet due to a slight delay. Once announced, they will be visible here. Thank you
					for your patience.
				</p>
			</div>
		</div>
	);
};

export default ResultsPendingScreen;
